module.exports = __webpack_public_path__ + "media/images/posts/puzzle-487c796c6c90956b5106f5e07b6f71d9.jpg";